export default "__VITE_ASSET__OE1TUQhQ__"